import { useEffect, useRef, useState } from 'react';
import './ContextMenu.css';
import {isSameLine} from './Funcs.js';

const ContextMenu = ({ contextMenu, selectedRect, onClipBoard, handleContextMenuAction, segments, aSegment, lines}) => {
  const menuRef = useRef(null);
  const [adjustedPosition, setAdjustedPosition] = useState(contextMenu);

  useEffect(() => {
    if (contextMenu && menuRef.current) {
      const menuHeight = menuRef.current.offsetHeight;
      const menuWidth = menuRef.current.offsetWidth;
      const { innerHeight, innerWidth } = window;

      let { x, y } = contextMenu;

      if (y + menuHeight > innerHeight) {
        y = Math.max(0, innerHeight - menuHeight - 10);
      }
      if (x + menuWidth > innerWidth) {
        x = Math.max(0, innerWidth - menuWidth - 10);
      }

      setAdjustedPosition({ x, y });
    }
  }, [contextMenu]);


  if (!contextMenu) 
  {    
    return null;
  }


  const renderMenu = (buttons, title = null) => (
    <div
      ref={menuRef}
      className="context-menu"
      onContextMenu={(e) => {
        e.preventDefault();   // Prevent system context menu
        e.stopPropagation();  // Optional: prevent bubbling just in case
      }}
      style={{
        position: 'fixed',
        top: adjustedPosition?.y ?? contextMenu.y,
        left: adjustedPosition?.x ?? contextMenu.x,
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        borderRadius: '4px',
        zIndex: 1000,
        padding: '0.25rem 0',
        minWidth: '200px'
      }}
    >
  
      {title && (
        <div
          style={{
            textAlign: 'center',
            fontWeight: 'bold',
            padding: '0.4rem 0',
            borderBottom: '1px solid #eee'
          }}
        >
          {title}
        </div>
      )}
  
      {buttons.map((btn, index) => (
        <div key={index}>
          <button
            className="context-menu-button2"
            onClick={() => handleContextMenuAction(btn.action)}
          >
            {btn.label}
          </button>
        </div>
      ))}
  
    </div>
  );

  /*
  const renderMenu = (buttons) => (
    <div
      ref={menuRef}
      className="context-menu"
      onContextMenu={(e) => {
        e.preventDefault();   // Prevent system context menu
        e.stopPropagation();  // Optional: prevent bubbling just in case
      }}
      style={{
        position: 'fixed',
        top: adjustedPosition?.y ?? contextMenu.y,
        left: adjustedPosition?.x ?? contextMenu.x,
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        borderRadius: '4px',
        zIndex: 1000,
        padding: '0.25rem 0',
        minWidth: '200px'
      }}
    >
      {buttons.map((btn, index) => (
        <div key={index}>    
          <button
              key={index}
              className="context-menu-button2"
              onClick={() => handleContextMenuAction(btn.action)}
            >
              {btn.label}
            </button>      
        </div>
      ))}
    </div>
  );
  */

  if(onClipBoard === true)
  {
    return renderMenu([
      { label: 'Select', action: 'paste' },
      { label: 'Clear Clipboard', action: 'clearC' }]);
  }

  if(segments.length >= 1)
  {
    
   //  console.log(JSON.stringify(lines));
    if(aSegment != null && lines.length > 0)
    {
      if(lines[aSegment.lineIndex].points.length >= 2)
      {
        return renderMenu([
          { label: 'Move Segment', action: 'moveSegment' },
          { label: 'Delete Segment', action: 'deleteSegment'},
          { label: 'Break Segment', action: 'breakSegment' }, 
          { label: 'Straighten Segment', action: 'straight'},       
          { label: 'Move Line', action: 'moveLine'},     

        ], "Line Segment");
      }  
    }

    let sameLine = isSameLine(segments);

    if(!sameLine)
    {
        return renderMenu([
          { label: 'Move All', action: 'moveAll' },    
          { label: 'Move Selected', action: 'moveSelected'},
          { label: 'Copy Selected', action: 'copySelected'},
          { label: 'Delete Selected', action: 'deleteSelected'},
          {label: 'Settings', action: 'settings'}], "Lines");
    }

    return renderMenu([
          {label: 'Move All', action: 'moveAll' },
          {label: 'Move Line', action: 'moveLine'},
          {label: 'To Front', action: 'lineToFront'},
          {label: 'To Back', action: 'lineToBack'},
          {label: 'Copy Line', action: 'copyLine'},
          {label: 'Delete Line', action: 'deleteLine'},
          {label: 'Join Line', action: 'joinLine'},
          {label: 'Mirror Line', action: 'mirrorLine'},
          {label: 'Rotate Line', action: 'rotateLine'},
          {label: 'Resize Line', action: 'resizeLine'},
          { label: 'Smooth Bezier', action: 'smoothBezier' },  
          {label: 'Settings', action: 'settings'},], "A Line");

  }

  if(selectedRect.length === 0)
  {
    return renderMenu([
      { label: 'Page Settings', action: 'pageSettings' },
      { label: 'Copy Page From', action: 'copyPage' },
    ], "Page Menu");
  }

  if (selectedRect.length === 1) {

    let lockString = "Lock";
    if(selectedRect[0].locked=== true)
    {
      lockString = 'Unlock';
    }


    if(selectedRect[0].type === 'Menubar')
    {
      return renderMenu([
        { label: `${lockString}`, action: 'lock' },
        { label: 'Move', action: 'move' },
        { label: 'Delete', action: 'delete' },        
        { label: 'Resize', action: 'resize' },
        { label: 'Expand Upwards', action: 'expandUp' },
        { label: 'Expand Leftwards', action: 'expandLeft' },
        { label: 'Expand Rightwards', action: 'expandRight' },
        { label: 'Expand Downwards', action: 'expandDown' }
      ]);
    }

    if(selectedRect[0].type === 'Link' || (selectedRect[0].type === 'Rectangle' && selectedRect[0].subType === "Text"))
    {
      
      return renderMenu([
        { label: `${lockString}`, action: 'lock' },
        { label: 'Move', action: 'move' },
        { label: 'Delete', action: 'delete' },
        { label: 'Copy', action: 'copy' },
        { label: 'Push To Back', action: 'back' },
        { label: 'Push To Front', action: 'front' },
        { label: 'Copy To Clipboard', action: 'copyTo' },        
        { label: 'Resize', action: 'resize' },
        { label: 'Expand Upwards', action: 'expandUp' },
        { label: 'Expand Leftwards', action: 'expandLeft' },
        { label: 'Expand Rightwards', action: 'expandRight' },
        { label: 'Expand Downwards', action: 'expandDown' },
        { label: 'Html Editor', action: 'htmlEditor' },
      ], "HUMAN HTML");
    }

    if(selectedRect[0].type === 'Rectangle' && selectedRect[0].subType === "Image")
    {
      let bExtra = [];
      
      if(selectedRect[0].imageName !== "" && selectedRect[0].imageName.toLowerCase().endsWith("svg"))
      {
        bExtra.push({ label: 'Copy To Bezier', action:'convertToBezier'});
      }
      return renderMenu([
        { label: `${lockString}`, action: 'lock' },
        { label: 'Move', action: 'move' },
        { label: 'Delete', action: 'delete' },
        { label: 'Copy', action: 'copy' },
        { label: 'Push To Back', action: 'back' },        
        { label: 'Push To Front', action: 'front' },
        { label: 'Copy To Clipboard', action: 'copyTo' },
        ...bExtra,
        { label: 'Resize', action: 'resize' },
        { label: 'Rotate', action: 'rotate' },
        { label: 'Expand Upwards', action: 'expandUp' },
        { label: 'Expand Leftwards', action: 'expandLeft' },
        { label: 'Expand Rightwards', action: 'expandRight' },
        { label: 'Expand Downwards', action: 'expandDown' },
        { label: 'Image Selector', action:'imageSelect'},  
        { label: 'Modify With AI', action:'aiModifyImagePrompt'},
        { label: 'Link', action:'link'}
      ], selectedRect[0].subType);
    }

    if(selectedRect[0].type === 'Rectangle' && (selectedRect[0].subType === "SvgRect" ||
                                                selectedRect[0].subType === "SvgSquare"))
    {
      return renderMenu([
        { label: `${lockString}`, action: 'lock' },
        { label: 'Move', action: 'move' },
        { label: 'Delete', action: 'delete' },
        { label: 'Copy', action: 'copy' },
        { label: 'Push To Back', action: 'back' },
        { label: 'Push To Front', action: 'front' },
        { label: 'Copy To Clipboard', action: 'copyTo' },
        { label: 'Copy To Bezier', action:'convertToBezier'},
        { label: 'Resize', action: 'resize' },
        { label: 'Rotate', action: 'rotate' },
        { label: 'Expand Upwards', action: 'expandUp' },
        { label: 'Expand Leftwards', action: 'expandLeft' },
        { label: 'Expand Rightwards', action: 'expandRight' },
        { label: 'Expand Downwards', action: 'expandDown' },
        { label: 'Clip', action: 'clip' },
        { label: 'Image Adjust', action:'imageAdjust'},
        {label: 'Settings', action: 'settings'},
        {label: 'Effects', action: 'effects'},
        { label: 'Link', action:'link'}
      ], selectedRect[0].subType);
    }

    if(selectedRect[0].type === 'Rectangle' && (selectedRect[0].subType === "SvgCircle" || 
                                                  selectedRect[0].subType === "SvgEllipse"))
    {
        return renderMenu([
        { label: `${lockString}`, action: 'lock' },
        { label: 'Move', action: 'move' },
        { label: 'Delete', action: 'delete' },
        { label: 'Copy', action: 'copy' },
        { label: 'Push To Back', action: 'back' },
        { label: 'Push To Front', action: 'front' },
        { label: 'Copy To Clipboard', action: 'copyTo' },
        { label: 'Copy To Bezier', action:'convertToBezier'},
        { label: 'Resize', action: 'resize' },
        { label: 'Rotate', action: 'rotate' },
        { label: 'Expand Upwards', action: 'expandUp' },
        { label: 'Expand Leftwards', action: 'expandLeft' },
        { label: 'Expand Rightwards', action: 'expandRight' },
        { label: 'Expand Downwards', action: 'expandDown' },
        { label: 'Clip', action: 'clip' },
        { label: 'Image Adjust', action:'imageAdjust'},
        {label: 'Settings', action: 'settings'},
        {label: 'Effects', action: 'effects'},
        { label: 'Link', action:'link'}
        ], selectedRect[0].subType);
    }



    if(selectedRect[0].type === 'Group')
    {
      return renderMenu([
        { label: `${lockString}`, action: 'lock' },
        { label: 'Move', action: 'move' },
        { label: 'Delete', action: 'delete' },
        { label: 'Copy', action: 'copy' },
        { label: 'Push To Back', action: 'back' },
        { label: 'Push To Front', action: 'front' },
        { label: 'Copy To Clipboard', action: 'copyTo' },
        { label: 'Copy To Bezier', action:'convertToBezier'},
        { label: 'Resize', action: 'resize' },
        { label: 'Rotate', action: 'rotate' },
        { label: 'Ungroup', action: 'ungroup' },        
        { label: 'Clip', action: 'clip' },
        { label: 'Image Adjust', action:'imageAdjust'},
        { label: 'Settings', action: 'settings'},
        { label: 'Effects', action: 'effects'},
        { label: 'Link', action:'link'}

      ], selectedRect[0].type);
    }

    if(selectedRect[0].type === 'Rectangle' && selectedRect[0].subType === "Custom")
    {
      return renderMenu([
        { label: `${lockString}`, action: 'lock' },
        { label: 'Move', action: 'move' },
        { label: 'Delete', action: 'delete' },
        { label: 'Copy', action: 'copy' },
        { label: 'Push To Back', action: 'back' },
        { label: 'Push To Front', action: 'front' },
        { label: 'Copy To Clipboard', action: 'copyTo' },
        { label: 'Resize', action: 'resize' },
        { label: 'Expand Upwards', action: 'expandUp' },
        { label: 'Expand Leftwards', action: 'expandLeft' },
        { label: 'Expand Rightwards', action: 'expandRight' },
        { label: 'Expand Downwards', action: 'expandDown' },
        { label: 'Generate Code With AI', action: 'aiGenerateCode' },
        { label: 'Edit AI Code', action: 'aiEditCode' },
        { label: 'Export AI Code', action: 'exportCode' },
      ], "AI HTML");      
    }

    if(selectedRect[0].type === 'Rectangle' && selectedRect[0].subType === "AiArt")
    {
      return renderMenu([
        { label: `${lockString}`, action: 'lock' },
        { label: 'Move', action: 'move' },
        { label: 'Delete', action: 'delete' },
        { label: 'Copy', action: 'copy' },
        { label: 'Push To Back', action: 'back' },
        { label: 'Push To Front', action: 'front' },
        { label: 'Copy To Clipboard', action: 'copyTo' },
        { label: 'Resize', action: 'resize' },
        { label: 'Expand Upwards', action: 'expandUp' },
        { label: 'Expand Leftwards', action: 'expandLeft' },
        { label: 'Expand Rightwards', action: 'expandRight' },
        { label: 'Expand Downwards', action: 'expandDown' },
        { label: 'Generate Bezier With AI', action:'aiPrompt'},
        { label: 'Generate Image With AI', action:'aiImagePrompt'}
      ], "AI ART");      
    }



    if(selectedRect[0].type === 'Rectangle' && selectedRect[0].subType === "Animate")
    {
      return renderMenu([
        { label: `${lockString}`, action: 'lock' },
        { label: 'Move', action: 'move' },
        { label: 'Delete', action: 'delete' },
        { label: 'Copy', action: 'copy' },
        { label: 'Push To Back', action: 'back' },
        { label: 'Push To Front', action: 'front' },
        { label: 'Copy To Clipboard', action: 'copyTo' },
        { label: 'Resize', action: 'resize' },
        { label: 'Rotate', action: 'rotate' },
        { label: 'Settings', action:'animateSettings'}
      ], selectedRect[0].subType);      
    }

    
    if(selectedRect[0].type === 'Prect')
    {

      let r = selectedRect[0];
      let p = r.path;
      
      let extra = [ { label: 'Clip', action: 'clip'},
                    { label: 'Image Adjust', action:'imageAdjust'},
                    {label: 'Settings', action: 'settings'},
                    {label: 'Effects', action: 'effects'}];
      if(p.length > 1)
      {

        extra = [];

      }

      let bExtra = [];

      if(selectedRect[0].subType !== "FreeHand")
      {
        bExtra = [{ label: 'Copy To Bezier', action:'convertToBezier'}];
      }
      else
      {
        bExtra = [{ label: 'Copy To Bezier', action:'convertToBezier'},
                    {label: 'Settings', action: 'settings'}];
      }
      
      return renderMenu([
        { label: `${lockString}`, action: 'lock' },
        { label: 'Move', action: 'move' },
        { label: 'Delete', action: 'delete' },
        { label: 'Copy', action: 'copy' },
        { label: 'Push To Back', action: 'back' },
        { label: 'Push To Front', action: 'front' },
        { label: 'Copy To Clipboard', action: 'copyTo' },
        ...bExtra,
        { label: 'Resize', action: 'resize' },
        { label: 'Rotate', action: 'rotate' },
        { label: 'Flip Vertical', action: 'flipV' },
        { label: 'Flip Horizontal', action: 'flipH' },
        ...extra,
        { label: 'Link', action:'link'},
        { label: 'Explode', action: 'explode'}
      ], selectedRect[0].type);
    }

    if(selectedRect[0].type === 'Bezier')
    {
      let r = selectedRect[0];
      let p = r.path;
      
      let extra = [ { label: 'Clip', action: 'clip'},
                    { label: 'Image Adjust', action:'imageAdjust'},
                    {label: 'Settings', action: 'settings'},
                    {label: 'Effects', action: 'effects'}];
      if(p.length > 1)
      {

        extra = [];

      }


      return renderMenu([
        { label: `${lockString}`, action: 'lock' },
        { label: 'Move', action: 'move' },
        { label: 'Delete', action: 'delete' },
        { label: 'Copy', action: 'copy' },
        { label: 'Push To Back', action: 'back' },
        { label: 'Push To Front', action: 'front' },
        { label: 'Copy To Clipboard', action: 'copyTo' },
        { label: 'Resize', action: 'resize' },
        { label: 'Rotate', action: 'rotate' },
        { label: 'Flip Vertical', action: 'flipV' },
        { label: 'Flip Horizontal', action: 'flipH' },
        ...extra,
        { label: 'Emojis', action: 'emoji'},
        { label: 'Export SVG', action: 'exportSvg'},        
        { label: 'Import SVG', action: 'importSvg'},        
        { label: 'Link', action:'link'},
        { label: 'Modify With AI', action:'aiPrompt'},
        { label: 'AI Transform Into Image', action:'aiImagePrompt'},
        { label: 'Generate Code With AI', action: 'aiGenerateCode' },
        { label: 'Explode', action: 'explodeB'}

      ], selectedRect[0].type);
    }


    // { label: 'Text Options', action: 'textOptions'}
    if(selectedRect[0].type === 'SvgText')
    {
      return renderMenu([
        { label: `${lockString}`, action: 'lock' },
        { label: 'Move', action: 'move' },
        { label: 'Delete', action: 'delete' },
        { label: 'Copy', action: 'copy' },
        { label: 'Push To Back', action: 'back' },
        { label: 'Push To Front', action: 'front' },
        { label: 'Copy To Clipboard', action: 'copyTo' },
        { label: 'Copy To Bezier', action:'convertToBezier'},
        { label: 'Resize', action: 'resize' },
        { label: 'Rotate', action: 'rotate' },
        { label: 'Text Options', action: 'settings'},
        {label: 'Effects', action: 'effects'},
        { label: 'Link', action:'link'}
      ], selectedRect[0].type);
    }
  }

  if (selectedRect.length > 1) {
    return renderMenu([
      { label: 'lockAll', action: 'lockAll' },
      { label: 'unlockAll', action: 'unLockAll' },
      { label: 'Move', action: 'move' },
      { label: 'Delete', action: 'delete' },
      { label: 'Copy', action: 'copy' },
      { label: 'Push To Back', action: 'back' },
      { label: 'Push To Front', action: 'front' },
      { label: 'Align Top', action: 'alignTop' },
      { label: 'Align Left', action: 'alignLeft' },
      { label: 'Align Right', action: 'alignRight' },
      { label: 'Align Bottom', action: 'alignBottom' },
      { label: 'Group Together', action: 'groupTogether' },

    ], "Multi Select");
  }
  
  console.log ("NO MENU");
  return null;
};

export default ContextMenu;
